import React from 'react';
import classNames from 'classnames';

import ButtonLink, { TButtonLinkProps } from '~/components/atoms/ButtonLink';

import styles from './StyledButton.module.scss';

export enum EStyledButtonVariant {
  WHITE = 'white',
  BLUE = 'blue',
  GRAY = 'gray',
  DARK = 'dark',
  TRANSPARENT = 'transparent',
}

type TStyledButtonProps = TButtonLinkProps & {
  variant?: EStyledButtonVariant;
};

const StyledButton: React.FC<TStyledButtonProps> = ({
  variant = EStyledButtonVariant.BLUE,
  className,
  ...rest
}) => (
  <ButtonLink
    className={classNames(styles.base, styles[variant], className)}
    {...rest}
  />
);

export default StyledButton;
